import * as moment from 'moment';

import { APP_LOCAL_DATETIME_FORMAT } from 'app/config/constants';

export const convertDateTimeFromServer = date => (date ? moment.default(date).format(APP_LOCAL_DATETIME_FORMAT) : null);
